import { render } from "./editpurchaseinvoice.vue?vue&type=template&id=a157f348&scoped=true"
import script from "./editpurchaseinvoice.vue?vue&type=script&lang=js"
export * from "./editpurchaseinvoice.vue?vue&type=script&lang=js"

import "./editpurchaseinvoice.vue?vue&type=style&index=0&id=a157f348&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a157f348"]])

export default __exports__